import React, { ReactNode } from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

interface ErrorBoundaryWrapperProps {
  children: ReactNode;
}

const ErrorFallback = ({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) => (
  <div className="h-screen flex flex-col items-center justify-center text-center">
    <h2 className="text-2xl font-semibold text-red-500">
      Oops! Something went wrong.
    </h2>
    <p className="text-gray-700">{error.message}</p>
    <button
      onClick={resetErrorBoundary}
      className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md"
    >
      Retry
    </button>
  </div>
);

const ErrorBoundaryWrapper: React.FC<ErrorBoundaryWrapperProps> = ({
  children,
}) => (
  <ReactErrorBoundary
    FallbackComponent={ErrorFallback}
    onReset={() => {
      window.location.reload();
    }}
  >
    {children}
  </ReactErrorBoundary>
);

export default ErrorBoundaryWrapper;
